import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=166fc45e&scoped=true"
import script from "./CopyBtn.vue?vue&type=script&lang=js"
export * from "./CopyBtn.vue?vue&type=script&lang=js"
import style0 from "./CopyBtn.vue?vue&type=style&index=0&id=166fc45e&prod&lang=scss"
import style1 from "./CopyBtn.vue?vue&type=style&index=1&id=166fc45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fc45e",
  null
  
)

export default component.exports